import { Component, OnInit, Inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { KnowledgeSectionService } from '../knowledge-section.service';
import { ToastrService } from 'ngx-toastr';
import { CarouselConfig } from 'ngx-bootstrap/carousel';
import { NgxSpinnerService } from "ngx-spinner";
import { style, animate } from '@angular/animations';
import { PageScrollService } from 'ngx-page-scroll-core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-interview',
  templateUrl: './interview.component.html',
  styleUrls: ['./interview.component.scss'],
  providers: [
    { provide: CarouselConfig, useValue: { interval: 1500, noPause: true, showIndicators: true } }
  ]
})
export class InterviewComponent implements OnInit {

  itemsPerPage = 5;
  maxSize = 4;
  totalItems : any=0;
  page: number = 1;
  type = 'interview';
  interview : any;
  imageBasePath = environment.imgUrl;
  sliderData : any;
  cycleInterval = 2500;
  totalPages = 0;
  showPagination:boolean = false
  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,
    arrows: true
  }
  animateLeft = [
    style({ opacity: 0, transform: 'translateX(100px)' }),
    animate('1200ms cubic-bezier(0.35, 0, 0.25, 1)', style({ opacity: 1, transform: 'translateX(0)' })),
  ];

  constructor( private router: Router,private service : KnowledgeSectionService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private pageScrollService: PageScrollService, 
    @Inject(DOCUMENT) private document: any,
    private titleService:Title) { }

  ngOnInit(): void {
    this.titleService.setTitle("Interviews | Social App Hub");
    this.loadPage();
    this.getSliderImages();
  }

  loadPage():void{
    this.spinner.show();
    this.service.getInterview(this.page).subscribe((data: any) => {
      this.spinner.hide();
			if (data.status === 200) {
        this.showPagination = true;
        this.interview = data.body.interviews;
        this.totalItems = data.body.interview_count;
        this.totalPages = (this.totalItems%this.itemsPerPage) == 0 ? (this.totalItems/this.itemsPerPage): (Math.trunc(this.totalItems/this.itemsPerPage) + 1)
			}
		}, err => {
      this.spinner.hide();
			this.toastr.error(err.error.message, '');
		});
  }

  pageChanged(event: any): void {
    this.page = event.page;
    this.pageScrolling('#scrollingToTop')
    this.loadPage();
  }

  getSliderImages(): void {
    this.service.getInterviewSliderImages().subscribe((data: any) => {
      if (data.status === 200) {
        this.sliderData = data.body.sliders;
      }
    }, err => {
      this.toastr.error(err.error.message, '');
    });
  }
  pageScrolling(nameOfClass){
    this.pageScrollService.scroll({
      document: this.document,
      scrollTarget: nameOfClass
    });
  }

  itemClickOnNgxClick(data){
    this.router.navigate(['/knowledge-section/interview/detail',data?._id])    
  }

}
